import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildSettingsUrl = (endpoint = "") =>
  `${API_ROUTES.API.BASE}${API_ROUTES.API.USER_SETTINGS}${endpoint ? `/${endpoint}` : ""}`

export const bundleService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserSettings: builder.query({
      query: () => ({
        url: buildSettingsUrl(),
        method: "GET",
      }),
    }),

    bulkUpdateUserSettings: builder.mutation({
      query: (settings) => ({
        url: buildSettingsUrl("bulk_update"),
        method: "POST",
        body: { settings },
      }),
    }),
  }),
})

export const {
  useGetUserSettingsQuery,
  useLazyGetUserSettingsQuery,
  useBulkUpdateUserSettingsMutation,
} = bundleService
